<template>
  <div class="detail">
    <video-player
      :baseUrl="curData.baseUrl"
      :videoUrl="curData.videoUrl"
      :title="curData.title"
      :setNum="curData.setNum"
      :num="curData.num"
      :videoFormat="curData.videoFormat"
    ></video-player>

    <div class="content" style="clear: both; height: 700px">
      <evaluate-box></evaluate-box>

      <ranking-box :rankingList="rankingList"></ranking-box>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "./VideoPlayer.vue";
import EvaluateBox from "./EvaluateBox.vue";
import RankingBox from "./RankingBox.vue";

export default {
  name: "PatrioticDetail",
  components: { VideoPlayer, EvaluateBox, RankingBox },
  data() {
    return {
      pageData: {
        1: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/earth/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/earth/1.mp4",
          title: "跟我一起探索宇宙",
          setNum: 8,
          videoFormat: "mp4",
          num: "1",
        },
        2: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/mars/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/mars/1.mp4",
          title: "关于火星的小秘密",
          setNum: 8,
          videoFormat: "mp4",
          num: "1",
        },
        3: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country/1.mp4",
          title: "礼花弹爱国视频",
          setNum: 5,
          videoFormat: "mp4",
          num: "1",
        },
        4: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/space/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/space/1.mp4",
          title: "奇妙的航天知识",
          setNum: 9,
          videoFormat: "mp4",
          num: "1",
        },
        5: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country1/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country1/1.mp4",
          title: "强国课堂第一季系列（1）",
          setNum: 8,
          videoFormat: "mp4",
          num: "1",
        },
        6: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country2/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country2/1.mp4",
          title: "强国课堂第一季系列（2）",
          setNum: 12,
          videoFormat: "mp4",
          num: "1",
        },
        7: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country3/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/country3/1.mp4",
          title: "强国课堂第一季系列（3）",
          setNum: 11,
          videoFormat: "mp4",
          num: "1",
        },
        8: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/sky1/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/sky1/1.mp4",
          title: "太空请回答1",
          setNum: 8,
          videoFormat: "mp4",
          num: "1",
        },
        9: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/sky2/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/sky2/1.mp4",
          title: "太空请回答2",
          setNum: 1,
          videoFormat: "mp4",
          num: "1",
        },
        10: {
          baseUrl: "https://eaydu-video.oss-cn-beijing.aliyuncs.com/story/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/story/1.mp4",
          title: "学而思爱国课堂将军爷爷讲故事",
          setNum: 16,
          videoFormat: "mp4",
          num: "1",
        },
        11: {
          baseUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/spaceclass/",
          videoUrl:
            "https://eaydu-video.oss-cn-beijing.aliyuncs.com/spaceclass/1.mp4",
          title: "杨利伟给青少年的航天课",
          setNum: 8,
          videoFormat: "mp4",
          num: "1",
        },
      },
      curData: {},
      rankingList: [
        {
          title: "跟我一起探索宇宙",
          views: "5230",
          path: "/patrioticDetail",
          id: 1,
        },
        {
          title: "关于火星的小秘密",
          views: "2230",
          path: "/patrioticDetail",
          id: 2,
        },
        {
          title: "礼花弹爱国视频",
          views: "1230",
          path: "/patrioticDetail",
          id: 3,
        },
        {
          title: "奇妙的航天知识",
          views: "20",
          path: "/patrioticDetail",
          id: 4,
        },
        {
          title: "强国课堂第一季系列（1）",
          views: "10",
          path: "/patrioticDetail",
          id: 5,
        },
      ],
    };
  },
  watch: {
    $route: {
      handler() {
        const pageId = this.$route.query.id;
        this.curData = this.pageData[pageId];
      },
      deep: true,
    },
  },
  created() {
    const pageId = this.$route.query.id;
    this.curData = this.pageData[pageId];
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.detail {
  width: 100%;
  padding: 110px 100px 20px;
  .content {
    position: relative;
  }
}
</style>